export default __webpack_public_path__ + "static/media/video-play-icon.92594855.svg";